import React, { useState, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import {
    Typography,
} from '@mui/material';
import styled from 'styled-components';

import { FormReCaptchaInterface } from '../../Models/Common/FormFieldComponentInterfaces';

import LocalStorageHelper from '../../Utilities/Helpers/LocalStorageHelper';

import { GlobalSettingsConstants } from '../../Constants/GlobalConstants';

const RecaptchaContainer = styled.div<{ $isError?: boolean; $darkMode?: boolean; }>`
    width: 100%;
    justify-items: center;
    margin: 10px 0px 0px 0px;

    .fieldContainer {
        padding: 0px;
        box-shadow: none;
        width: 302px;
        height: 76px;
        border: 1px solid;
        border-radius: 4px;
        overflow: hidden;
        border-color:  ${props => props?.$isError ? "#f44336" : (props.$darkMode ? '#ffffff3b' : '#0000003b')} !important;

        div {
            &:first-of-type {
                margin: -1px 0px 0px -0.2px;
            }
        }
    }

    .errorMessageText {
        font-size: 0.75rem;
        font-weight: 400;
        color: #f44336;
        margin: 3px 0px 0px 0px;
    }
`;


const FormReCaptcha: any = (fieldProps: FormReCaptchaInterface) => {
    let isDarkMode = LocalStorageHelper.isDarkMode();
    const errorMsg = (fieldProps.errorMessages ? fieldProps.errorMessages[fieldProps.name] : null) ?? null;

    const renderFilePickerUI = () => {
        return <div className="fieldContainer">
            <ReCAPTCHA
                sitekey={GlobalSettingsConstants.RECAPTCHA_API_KEY ?? ""}
                onChange={(e: any) => {
                    if(fieldProps?.handleOnChange) {
                        fieldProps.handleOnChange(e);
                    }
                }} />
        </div>
    }

    return <RecaptchaContainer $isError={errorMsg != null && errorMsg != ""} $darkMode={isDarkMode} className={"recaptchaContainer " + (fieldProps?.fieldClassName != null && fieldProps?.fieldClassName != "" ? fieldProps.fieldClassName : "")}>
        {renderFilePickerUI()}

        {errorMsg != null && errorMsg != "" && <Typography className="errorMessageText">{errorMsg}</Typography>}
    </RecaptchaContainer>
}

export default FormReCaptcha;